// NOTE: dont export outside package scope

export const $$PROMPT_EVENT = '$$prompt.prompt'
export const $$ANSWER_EVENT = '$$prompt.answer'
